const EyeSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_9339_1352)">
        <path
          d="M13 6.74778C13 6.74778 10.7041 9.66536 8.08092 9.66536C5.45776 9.66536 3 6.80283 3 6.80283C3 6.80283 5.45776 3.83203 8.08092 3.83203C10.7041 3.83203 13 6.74778 13 6.74778Z"
          stroke="#D5D5D5"
          strokeWidth="0.916667"
          strokeMiterlimit="10"
        />
        <path
          d="M8 8C8.69036 8 9.25 7.44036 9.25 6.75C9.25 6.05964 8.69036 5.5 8 5.5C7.30964 5.5 6.75 6.05964 6.75 6.75C6.75 7.44036 7.30964 8 8 8Z"
          stroke="#D5D5D5"
          strokeWidth="0.916667"
          strokeMiterlimit="10"
        />
        <path d="M3.83203 12.166H12.1654" stroke="#D5D5D5" strokeWidth="0.916667" strokeMiterlimit="10" strokeLinecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_9339_1352">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EyeSvg;
